/** 手機直播／重播頁橫向時，通知根層隱藏 LanguageDropdown */
const EVENT_NAME = 'bombmy:hideLanguageDropdownStreamHorizon'

export function publishHideLanguageDropdownForStreamHorizon(hide) {
  window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: { hide: Boolean(hide) } }))
}

export function subscribeHideLanguageDropdownForStreamHorizon(listener) {
  const handler = (e) => {
    listener(Boolean(e.detail?.hide))
  }
  window.addEventListener(EVENT_NAME, handler)
  return () => window.removeEventListener(EVENT_NAME, handler)
}
